<template>
	<v-container grid-list-xl>
		<v-layout row wrap>		
			<v-flex lg12>
				<p>Please Note: Only .csv (comma seperated values) files are allowed for upload.</p>
				<p>The format and order of the import file must be as follows:</p>
				<p><strong>Description, Order, Is Order Status( Y / N ), Is Lock Status( Y / N )</strong></p>
				<p>Or download the import template <a href="http://www.myorder.myspec.co.za/myorder/docs/myorder_qs_import_template.csv" download>here</a></p>
				<p>The first row must be the column headers. Please confirm field validity and cardinality to ensure import integrity.</p>
				<input type="file" class="fileUpload" id="fileUpload" @change="fncCheckCsv">
				<div class="fileHolder">

					<p>Drag & Drop / Click to Add Files</p>					
					<small>{{ fileName }}</small>
				</div>			
			</v-flex>			
			<div class="pl-4 pr-1 pb-2 pt-2 buttonHolder">
				<div style="float: right">
					<v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
					<v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>
					<v-btn color="success" class="text-xs-right" v-if="!runAdd" :disabled="!uploadValue" @click.stop="fncImportStatus()">Import</v-btn>
                  <small>* The button will activate once all required fields have been completed</small>
				</div>	
			</div>
			<!--<v-flex lg12 class="requiredMessage">
				<small><strong>* The button will activate once all required fields have been completed.</strong></small>
			</v-flex>-->
			</v-layout>			
		</v-layout>
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex';	
	export default {
	  name: 'Settings',
	  data () {
			return {
				runAdd: false,
				objRows : '',
				fileName: '',
				uploadValue: false
			};
		},		
		methods: {
			fncHideModal () {
				this.$store.commit('hideModal');
			},
			fncImportStatus () {
				this.$store.dispatch('fncImportStatus', this.objRows)
			},
			fncCheckCsv(e) {				
				var files = e.target.files || e.dataTransfer.files;
				if( files[0].type === 'application/vnd.ms-excel' ) {
                    var reader = new FileReader();
                    var vm = this;
                    reader.onload = function(e) {
                        var quoteStatusRows = reader.result;
                        vm.objRows = quoteStatusRows.split("\r\n");
                        vm.fileName = files[0].name;
                    }
                    reader.readAsText(files[0]);
                    this.uploadValue = true;
				} else {
				    var elFile = document.getElementById('fileUpload');
				    	elFile.value = '';
                    var snackDetails = {color: 'error', message: 'Please ensure that a CSV file has been uploaded', display: true};
                    this.$store.commit('setSnack', snackDetails);
				}
			}
		},
		computed: {
			...mapGetters([			
				'objAuthorize',				
				'globalModalParams',				
			])
		}
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>